import { render, staticRenderFns } from "./chartTurnoverMonths.vue?vue&type=template&id=87837dca&scoped=true&"
import script from "./chartTurnoverMonths.vue?vue&type=script&lang=js&"
export * from "./chartTurnoverMonths.vue?vue&type=script&lang=js&"
import style0 from "./chartTurnoverMonths.vue?vue&type=style&index=0&id=87837dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87837dca",
  null
  
)

export default component.exports